import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initPostHog } from './lib/telemetry/posthog/frontend';
import './index.css';

// Initialize analytics before React mounts so child providers can safely
// identify the user, attach organization context, and evaluate release flags.
initPostHog();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Note: the inline #boot-loader (index.html) is removed by App.tsx via
// useLayoutEffect on mount. Doing it there guarantees the React tree has
// rendered and is ready to paint before the boot loader disappears, so
// there is never a blank-frame gap or a dual-loader overlap.
